"use client";

import { useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP, ScrollTrigger);
export default function Testimonials() {
  const container = useRef<HTMLElement>(null);
  const testimonials = [{
    quote: "",
    name: "",
    city: ""
  }, {
    quote: "",
    name: "",
    city: ""
  }, {
    quote: "",
    name: "",
    city: ""
  }, {
    quote: "",
    name: "",
    city: ""
  }, {
    quote: "",
    name: "",
    city: ""
  }, {
    quote: "",
    name: "",
    city: ""
  }];
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".n-eyebrow, .n-heading, .n-sub", {
        y: 16
      });
      const headerTl = gsap.timeline({
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
      headerTl.to(".n-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.4,
        ease: "power2.out"
      }).to(".n-heading", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out"
      }, "-=0.2").to(".n-sub", {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out"
      }, "-=0.35");
      gsap.set(".n-card", {
        y: 16
      });
      gsap.to(".n-card", {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".n-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".n-eyebrow", ".n-heading", ".n-sub", ".n-card"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="32667" ref={container} id="fullwidthcustomerreviews" data-nav="light" className="bg-background py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-5 md:px-6 lg:px-12">
        {}
        <div className="max-w-3xl">
          <div className="n-eyebrow flex items-center gap-3" style={{
          opacity: 0
        }}>
            <span aria-hidden="true" className="block h-[10px] w-px bg-primary" />
            <span className="font-default text-[0.8125rem] font-semibold uppercase tracking-[0.18em]" style={{
            color: "var(--primary)"
          }}>
              Client Testimonials
            </span>
            <span aria-hidden="true" className="block h-[10px] w-px bg-primary" />
          </div>

          <h2 className="n-heading mt-6 font-default font-semibold uppercase text-foreground" style={{
          opacity: 0,
          fontSize: "clamp(2.25rem, 5.5vw, 5rem)",
          lineHeight: 0.96,
          letterSpacing: "0.01em"
        }}>
            Trusted Results
          </h2>

          <p className="n-sub mt-6 font-default" style={{
          opacity: 0,
          color: "var(--muted-foreground)",
          fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
          lineHeight: 1.6
        }}>
            Hear from our clients across Akron, Barberton, and Massillon.
          </p>
        </div>

        {}
        <div className="n-grid mt-12 md:mt-16 [column-gap:20px] [column-count:1] md:[column-count:2] lg:[column-count:3]">
          {testimonials.map((t, i) => <figure data-index={i} key={i} className="n-card mb-5 inline-block w-full break-inside-avoid bg-card p-7" style={{
          opacity: 0
        }}>
              <span aria-hidden="true" className="block h-px w-[20%] bg-primary" />
              <blockquote className="mt-6 font-serif text-foreground" style={{
            fontWeight: 500,
            fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
            lineHeight: 1.5,
            letterSpacing: "-0.005em"
          }}>
                {t.quote}
              </blockquote>
              <figcaption className="mt-5 font-default" style={{
            color: "var(--muted-foreground)",
            fontSize: "0.875rem",
            fontWeight: 500,
            letterSpacing: "0.02em",
            lineHeight: 1.4
          }}>
                {t.name} · {t.city}
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}